import './CongTrinhThiCong.css'

const CongTrinhThiCongPage = () => {
  return (
    <div className="cong-trinh-thi-cong-page">
      <h1>Công Trình Thi Công</h1>
      <p>Khám phá các công trình thi công chất lượng cao của chúng tôi</p>
      {/* Nội dung trang công trình thi công sẽ được phát triển */}
    </div>
  )
}

export default CongTrinhThiCongPage
